var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { NameValueOfString, RegionType } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
var RegionTypesMultiSelectComponent = /** @class */ (function (_super) {
    __extends(RegionTypesMultiSelectComponent, _super);
    function RegionTypesMultiSelectComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this._exclude = [];
        _this.name = 'RegionTypeFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.regionTypeValues = RegionType;
        _this.options = new Array();
        _this._selectedItems = [];
        _this.placeholder = _this.l('Region');
        return _this;
    }
    Object.defineProperty(RegionTypesMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (items) {
            this._selectedItems = items || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RegionTypesMultiSelectComponent.prototype, "exclude", {
        set: function (exclude) {
            this._exclude = exclude;
            this.setRegionTypes();
        },
        enumerable: true,
        configurable: true
    });
    RegionTypesMultiSelectComponent.prototype.ngOnInit = function () {
        this.setRegionTypes();
    };
    RegionTypesMultiSelectComponent.prototype.regionTypeKeys = function () {
        var keys = Object.keys(this.regionTypeValues);
        return keys.slice(keys.length / 2);
    };
    RegionTypesMultiSelectComponent.prototype.setRegionTypes = function () {
        var _this = this;
        this.options = [];
        this.regionTypeKeys().forEach(function (e) {
            if (!_this._exclude.includes(e)) {
                _this.options.push(new NameValueOfString({ name: _this.l(e), value: _this.regionTypeValues[e] }));
            }
        });
    };
    RegionTypesMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return RegionTypesMultiSelectComponent;
}(AppComponentBase));
export { RegionTypesMultiSelectComponent };
